/* XYRA Signature. Progressive controls submit native Shopify forms.
   No automatic checkout, locale guessing or client-side text replacement. */
(() => {
 'use strict';
 const initialized = new WeakSet();
 const cleanup = new WeakMap();
 // Shopify owns locale selection. Preserve query state, such as variant and view.
 document.addEventListener('submit',event=>{
  const form=event.target;
  if(!(form instanceof HTMLFormElement)||!form.matches('[data-locale-form]'))return;
  let input=form.querySelector('[name="return_to"]');
  if(!input){input=document.createElement('input');input.type='hidden';input.name='return_to';form.append(input);}
  const current=new URL(location.href);
  current.searchParams.delete('section_id');current.searchParams.delete('sections');
  input.value=current.pathname+current.search+current.hash;
 });
 function init(root=document){
  root.querySelectorAll('[data-product-form]').forEach(form=>{
   if(initialized.has(form))return;initialized.add(form);
   const picker=form.querySelector('[data-variant-id]');
   const pills=form.querySelector('[data-option-pills]');
   const mainButton=form.querySelector('[data-add-button]');
   const section=form.closest('[data-product-section]');
   if(!picker||!mainButton||!section)return;
   if(pills){
    form.classList.add('has-option-pills');
    const sync=()=>pills.querySelectorAll('[data-pick-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pickVariant===picker.value)));
    pills.addEventListener('click',e=>{
     const button=e.target.closest('[data-pick-variant]');if(!button||form.dataset.busy==='true')return;
     picker.value=button.dataset.pickVariant;picker.dispatchEvent(new Event('change',{bubbles:true}));sync();
    });picker.addEventListener('change',sync);sync();
   }
   const bar=section.querySelector('[data-sticky-purchase]');
   const row=form.querySelector('.purchase-row');
   const price=section.querySelector('[data-product-price]');
   if(!bar||!row||!price)return;
   const secondary=bar.querySelector('[data-sticky-submit]');
   function syncBar(){
    secondary.disabled=mainButton.disabled;
    bar.querySelector('[data-sticky-label]').textContent=mainButton.querySelector('[data-add-label]')?.textContent||mainButton.textContent;
    const amount=price.querySelector('.price__current');bar.querySelector('[data-sticky-price]').textContent=(amount||price).textContent.trim().replace(/\s+/g,' ');
    secondary.setAttribute('aria-busy',String(form.dataset.busy==='true'));
   }
   secondary.addEventListener('click',e=>{
    e.preventDefault();if(secondary.disabled||mainButton.disabled)return;
    if(typeof form.requestSubmit==='function')form.requestSubmit(mainButton);else mainButton.click();
   });
   let visibilityFrame=0;
   const visibility=()=>{visibilityFrame=0;bar.hidden=row.getBoundingClientRect().bottom>0;};
   const scheduleVisibility=()=>{if(!visibilityFrame)visibilityFrame=requestAnimationFrame(visibility);};
   window.addEventListener('scroll',scheduleVisibility,{passive:true});window.addEventListener('resize',scheduleVisibility,{passive:true});visibility();
   const mutations=new MutationObserver(syncBar);mutations.observe(form,{attributes:true,childList:true,subtree:true,characterData:true});mutations.observe(price,{childList:true,subtree:true,characterData:true});
   cleanup.set(section,()=>{mutations.disconnect();window.removeEventListener('scroll',scheduleVisibility);window.removeEventListener('resize',scheduleVisibility);cancelAnimationFrame(visibilityFrame);});syncBar();
  });
 }
 document.addEventListener('shopify:section:load',e=>init(e.target));
 document.addEventListener('shopify:section:unload',e=>{e.target.querySelectorAll('[data-product-section]').forEach(s=>cleanup.get(s)?.());});
 init();
})();
